export default {"src":"/_next/static/media/InsuranceGroup-3_vertical.78522d72.svg","height":534,"width":82};